import $ from 'jquery';
import Cookies from '../vendors/jsCookie';

class GlobalPopup {

  constructor() {
    this.modal = $('.marsGlobalModal');
    this.gForm = $('.marsGlobalModal.show .gform_wrapper form');
    this.gFormEmail = $('.marsGlobalModal.show .gform_wrapper form .ginput_container_email input');
    this.getTargetModal();
  }

  events(id, uid) {
    let vm = this;
    // Disable modal on close event.
    $(id).on('hidden.bs.modal', function (e) {
      vm.setCookies(id, uid, true);
    });

    setTimeout(function () {
      //Disable modal on successful submit.
      let form = $(vm.gForm);
      if (form) {
        $("input[aria-required='true']").attr('required', true); //set attr required for all required inputs.
        let submitBtnId = $('.marsGlobalModal.show .gform_wrapper form input[type="submit"]').attr('id');
        $('#' + submitBtnId).on('click', function (e) {
          let email = $('.marsGlobalModal.show .gform_wrapper form .ginput_container_email input').val();
          if (vm.emailIsValid(email) && typeof email !== 'undefined') {
            vm.setCookies(id, uid, false);
          } else {
            // e.preventDefault();
            let emailContainer = $('.marsGlobalModal.show .gform_wrapper form .ginput_container_email');
            if (emailContainer) {
              ($('.gfield_description.validation_message').length ? 
                $('.gfield_description.validation_message').html('This field is required.') : 
                $(emailContainer).after(`<div class="gfield_description validation_message" aria-live="polite">This field is required.</div>`)
              );
              ($('.validation_error').length ? 
                $('.validation_error').html('There was a problem with your submission. Errors have been highlighted below.') : 
                $('.marsGlobalModal.show .gform_body').before(`<div class="validation_error">There was a problem with your submission. Errors have been highlighted below.</div>`)
              );
            }
          }
        });
      }
    }, 500);
  }

  orderModals(modals) {
    modals.sort(function (a, b) {
      var an = parseInt($(a).attr('data-priority'));
      var bn = parseInt($(b).attr('data-priority'));
      if (an > bn) {
        return 1;
      }
      if (an < bn) {
        return -1;
      }
      return 0;
    });
    return modals;
  }

  getTargetModal() {
    //in the case of having 2 modals on the same page, order modals by priority, then target the last one if it hasn't been deactivated by the user.
    let vm = this;
    let orderedList = vm.orderModals(vm.modal).get().reverse();

    $(orderedList).each(function (index) {
      let id = '#' + $(this).attr('id');
      let delay = $(this).attr('data-delay');
      let uid = $(this).attr('data-uid');
      let dOption = $(this).attr('data-displayOption');


      if (vm.checkCookies(id)) {
        if(dOption){
          setTimeout(() => {
            $(document).on("mouseout", evt => {
              if(evt.toElement === null && evt.relatedTarget === null) {
                $(evt.currentTarget).off("mouseout");
                // An intent to exit has happened
                if(!$(id).hasClass("oppened")){
                  vm.openModal(id);
                  vm.events(id, uid);
                  $(id).addClass("oppened");
                }
              }
            });
          }, 3000);
        }else{
          setTimeout(function () {
            vm.openModal(id);
            // ADD event listeners here:
            vm.events(id, uid);
          }, parseInt(delay));
        }



        return false;
      }
    });
  }

  checkCookies(id) {
    let satus = Cookies.get($(id).attr('data-uid'));
    if (!satus) {
      return true;
    }
    return false;
  }

  setCookies(id, uid, expires) {
    let vm = this;
    Cookies.set(uid, true, {
      expires: (expires ? 60 : 100000)
    });
    // vm.closeModal(id);
    // For more option: https://github.com/js-cookie/js-cookie
  }

  emailIsValid(email) {
    return /\S+@\S+\.\S+/.test(email)
  }

  openModal(id) {
    $(id).modal('show');
  }

  closeModal(id) {
    let vm = this;
    setTimeout(function () {
      $(id).modal('hide');
    }, 3000);
  }

}
export default GlobalPopup;